import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { NotifierService } from "../services/notifier.service";

/*
  Interceptor para tratamento de downloand de documentos da operação,
  no futuro, pode ser refatorado para tratar loading de toda a aplicação,
  a depender de como sera organizada a arquitetura do projeto.
*/
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly DOCUMENT_DOWNLOAD_ENDPOINTS = [
    "invoice/document/download",
    "lead/download/all/",
  ] as const;

  private readonly notifier = inject(NotifierService);

  intercept(request: HttpRequest<unknown>, handler: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isDocumentRequest(request)) {
      return handler.handle(request);
    }

    this.showDownloadStartMessage();

    return handler.handle(request).pipe(
      tap({
        next: event => {
          if (event instanceof HttpResponse && event.status === 200) {
            this.showDownloadSuccessMessage();
          }
        },
      }),
    );
  }

  private showDownloadStartMessage() {
    this.notifier.showNotification({
      message: "Baixando documento(s)...",
      alternative: "Isso pode levar alguns instantes.",
    });
  }

  private showDownloadSuccessMessage(): void {
    this.notifier.showNotification({
      message: "Download finalizado com êxito!",
      alternative: "Seus documentos foram baixados com sucesso.",
      messageType: "successNotifier",
    });
  }

  private isDocumentRequest(request: HttpRequest<unknown>): boolean {
    return this.DOCUMENT_DOWNLOAD_ENDPOINTS.some(endpoint => request.url.includes(endpoint));
  }
}
